import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import Reveal from 'react-reveal/Reveal'
import Container from '../components/Container'
import Intro from '../components/Intro'
import Social from '../components/Social'
import Footer from '../components/Footer'
import { Element } from 'react-scroll'

const Title = styled.h2`
  text-align: center;
  font-size: 2em;
  padding: 4rem 0 4rem 0;
  z-index: 99;
  position: relative;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    font-size: 2.25em;
  }
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 3em;
  }
`

const Text = styled.div`
  font-size: 1.1em;
  line-height: 1.5;
  margin: 0 auto;
  padding: 4rem 2rem 2rem;
  max-width: 800px;
  p {
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      font-size: 1.25rem;
    }
    margin: 0 0 2rem 0;
    &:last-child {
      margin: 0;
    }
  }
`

const Button = styled(Link)`
  display: block;
  font-size: inherit;
  color: #d93b31;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none !important;
  border: 2px solid #d93b31;
  background: #FFF;
  border-radius: 2px;
  padding: 1rem;
  margin: 2rem;
  &:hover {
    background: #d93b31;
    color: #FFF;
  }
`

const Action = styled(Link)`
  display: block;
  appearance: none;
  text-align: center;
  font-family: inherit;
  font-size: inherit;
  outline: none;
  background: white;
  border: 1px solid ${props => props.theme.colors.tertiary};
  color: ${props => props.theme.colors.base};
  border-radius: 2px;
  padding: 1em;
  margin: 3rem;
  &:focus {
    outline: none;
  }
  &:required {
    box-shadow: none;
  }
  &::-webkit-input-placeholder {
    color: gray;
  }
  &::-moz-placeholder {
    color: gray;
  }
  &:-ms-input-placeholder {
    color: gray;
  }
  &:-moz-placeholder {
    color: gray;
  }
`

const Heading = styled.h3`
  font-family: 'PT Serif', serif;
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.4;
  margin: 0 0 2rem 0;
  position: relative;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 1.75rem;
  }
`

const Flex = styled.div`
  display: flex;
  @media (max-width: ${props => props.theme.responsive.medium}) {
    display: block;
  }
`

const Column = styled.div`
  flex: 1;
`

const IndexPage = ({ data }) => (
  <Container>
    <Element key='1' name='main'>
      <Reveal>
        <Title>Voice Your Opposition To The Union Mandate In The BC Community Benefits Agreement</Title>
        <Intro />
        <Text>
          <Heading>Speak up now</Heading>
          <p>To add your voice in protest simply choose the appropriate letter below, entering your name and postal code to automatically send your letter to the Premier with a cc to your local MLA and MP.</p>
          <Flex>
            <Column>
              <Button to="/worker/">Skilled Tradesperson</Button>
            </Column>
            <Column>
              <Button to="/employer/">Construction Employer</Button>
            </Column>
          </Flex>
        </Text>
        <Social socialConfig={data} />
        <Footer />
      </Reveal>
    </Element>
  </Container>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js